import { makeStyles } from '@material-ui/core'

export interface NewMovimentation {
  status: boolean
}

export const useStyles = makeStyles((theme) => ({
  movimentationsTip: {
    marginBottom: 16,
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    '& img': {
      width: 20,
      marginLeft: 8
    },
    '& p': {
      color: theme.palette.primary.main,
      marginLeft: 4
    }
  },

  movimentationsWrapperOperator: {
    display: 'flex',
    width: '100%',
    marginTop: 8,
    height: 'auto'
  },

  movimentationsCreateNewMovimentation: {
    width: '100%'
  },

  movimentationsWrapperMulti: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    '& div': {
      flexGrow: 1
    }
  },

  movimentationsMultiSelectLot: {
    margin: '8px 16px 0 0',
    '& .MuiSelect-multiple': {
      fontFamily: theme.app.typography.fontFamily.main,
      fontSize: theme.app.typography.paragraph.fontSize,
      backgroundColor: theme.app.colors.input.background,
      border: `1px solid ${theme.app.colors.input.background}`,
      color: '#000',
      height: 18,
      '&:focus': {
        outline: 'none'
      },
      '&:disabled': {
        opacity: 0.5
      },
      '&:hover': {
        color: theme.app.colors.text.primary,
        backgroundColor: theme.palette.secondary.main
      }
    }
  },
  movimentationsMultiSelect: {
    margin: '8px 0 0 0',
    '& .MuiSelect-multiple': {
      fontFamily: theme.app.typography.fontFamily.main,
      fontSize: theme.app.typography.paragraph.fontSize,
      backgroundColor: theme.app.colors.input.background,
      border: `1px solid ${theme.app.colors.input.background}`,
      color: '#000',
      height: 18,
      '&:focus': {
        outline: 'none'
      },
      '&:disabled': {
        opacity: 0.5
      },
      '&:hover': {
        color: theme.app.colors.text.primary,
        backgroundColor: theme.palette.secondary.main
      }
    }
  },

  movimentationsMenuItem: {
    '& .css-12wnr2w-MuiButtonBase-root-MuiCheckbox-root.Mui-checked': {
      color: theme.palette.primary.main
    },
    '& .css-12wnr2w-MuiButtonBase-root-MuiCheckbox-root.MuiCheckbox-indeterminate': {
      color: theme.palette.primary.main
    },
    '& .css-kk1bwy-MuiButtonBase-root-MuiMenuItem-root.Mui-selected:hover': {
      backgroundColor: theme.palette.primary.main
    }
  },

  movimentationsMultiSelectRight: {
    borderRadius: 4,
    margin: '8px 0',
    '& .MuiSelect-multiple': {
      fontFamily: theme.app.typography.fontFamily.main,
      fontSize: theme.app.typography.paragraph.fontSize,
      backgroundColor: theme.app.colors.input.background,
      border: `1px solid ${theme.app.colors.input.background}`,
      color: '#000',
      height: 18,
      '&:focus': {
        outline: 'none'
      },
      '&:disabled': {
        opacity: 0.5
      },
      '&:hover': {
        color: theme.app.colors.text.primary,
        backgroundColor: theme.palette.secondary.main
      }
    }
  },

  movimentationsSelectOperator: {
    marginRight: 16,
    width: 160,
    '& .MuiSelect-select': {
      fontFamily: theme.app.typography.fontFamily.main,
      fontSize: theme.app.typography.paragraph.fontSize,
      backgroundColor: theme.app.colors.input.background,
      border: `1px solid ${theme.app.colors.input.background}`,
      color: '#000',
      height: 18,
      '&:focus': {
        outline: 'none'
      },
      '&:disabled': {
        opacity: 0.5
      },
      '&:hover': {
        color: theme.app.colors.text.primary,
        backgroundColor: theme.palette.secondary.main
      }
    }
  },

  movimentationsInput: {
    margin: '0 16px 0 32px',
    width: 300,
    flexGrow: 1,
    '& .custom-input__input': {
      height: 41,
      marginTop: 0
    }
  },

  movimentationsInputMonth: {
    width: 300,
    margin: '0 0 0 32px',
    flexGrow: 1,
    '& .custom-input__input': {
      height: 41,
      marginTop: 0
    }
  },

  movimentationsSelectGender: {
    margin: '8px 0 0 0',
    '& .MuiSelect-select': {
      fontFamily: theme.app.typography.fontFamily.main,
      fontSize: theme.app.typography.paragraph.fontSize,
      backgroundColor: theme.app.colors.input.background,
      border: `1px solid ${theme.app.colors.input.background}`,
      color: '#000',
      height: 18,
      '&:focus': {
        outline: 'none'
      },
      '&:disabled': {
        opacity: 0.5
      },
      '&:hover': {
        color: theme.app.colors.text.primary,
        backgroundColor: theme.palette.secondary.main
      }
    }
  },

  movimentationsSelectInput: {
    borderRadius: 4,
    fontFamily: theme.app.typography.fontFamily.main,
    fontSize: theme.app.typography.paragraph.fontSize,
    color: '#000',
    width: '100%'
  },

  movimentationsButtonContainer: {
    width: '100%',
    display: 'flex',
    marginLeft: 'auto',
    alignItems: 'center',
    justifyContent: 'flex-end',
    '& button': {
      margin: '0 0 0 16px'
    }
  },

  movimentationsButton: {
    marginTop: 21,
    width: 64
  },

  createMoreConditionsCreateNewMovimentation: {
    width: '100%'
  },

  createMoreConditionsWrapperOperator: {
    display: 'flex',
    width: '100%',
    marginTop: 8,
    height: 'auto'
  },

  createMoreConditionsSelectOperator: {
    marginRight: 16,
    width: 160,
    '& .MuiSelect-select': {
      fontFamily: theme.app.typography.fontFamily.main,
      fontSize: theme.app.typography.paragraph.fontSize,
      backgroundColor: theme.app.colors.input.background,
      border: `1px solid ${theme.app.colors.input.background}`,
      color: '#000',
      height: 18,
      '&:focus': {
        outline: 'none'
      },
      '&:disabled': {
        opacity: 0.5
      },
      '&:hover': {
        color: theme.app.colors.text.primary,
        backgroundColor: theme.palette.secondary.main
      }
    }
  },

  createMoreConditionsMenuItem: {
    '& .css-12wnr2w-MuiButtonBase-root-MuiCheckbox-root.Mui-checked': {
      color: theme.palette.primary.main
    },
    '& ..css-12wnr2w-MuiButtonBase-root-MuiCheckbox-root.MuiCheckbox-indeterminate': {
      color: theme.palette.primary.main
    },
    '& .css-kk1bwy-MuiButtonBase-root-MuiMenuItem-root.Mui-selected:hover': {
      backgroundColor: theme.palette.primary.main
    }
  },

  createMoreConditionsInput: {
    marginRight: 16,
    width: 300,
    flexGrow: 1,
    '& .custom-input__input': {
      height: 41,
      marginTop: 0
    }
  },

  createMoreConditionsInputMonth: {
    flexGrow: 1,
    '& .custom-input__input': {
      height: 41,
      marginTop: 0
    }
  }
}))
